import { ModelFieldConfig } from '@/types/model.types';
import { PlatformCreateUserGroup } from '@data/_generated-api/platform-api/models/platform-create-user-group';

export const userGroupEntityFormConfig: ModelFieldConfig<PlatformCreateUserGroup>[] = [
  {
    key: 'name',
    type: 'input',
    templateOptions: {
      label: 'Naam',
      required: true,
      maxLength: 64
    },
    focus: true
  }
];
